import React, { Component, ErrorInfo, ReactNode } from 'react';
import { KatButton } from '@amzn/katal-react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>We apologize for the inconvenience. Please try refreshing the page.</p>
          <KatButton
            onClick={() => window.location.reload()}
            variant="primary"
          >
            Refresh Page
          </KatButton>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;